import { render } from "./generateBoxid.vue?vue&type=template&id=28787ccb&scoped=true"
import script from "./generateBoxid.vue?vue&type=script&lang=js"
export * from "./generateBoxid.vue?vue&type=script&lang=js"

import "./generateBoxid.vue?vue&type=style&index=0&id=28787ccb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28787ccb"]])

export default __exports__